import { useEffect, useState } from 'react';
import { DetectedProject } from '../../../../utils/projectDetection';

export const useProjectSelections = (detectedProjects: DetectedProject[]) => {
  const [selectedProjects, setSelectedProjects] = useState<Set<string>>(
    new Set()
  );
  const [expandedProjects, setExpandedProjects] = useState<Set<string>>(
    new Set()
  );

  useEffect(() => {
    if (detectedProjects.length === 1) {
      setSelectedProjects(new Set([detectedProjects[0].folderPath]));
    } else {
      setSelectedProjects(new Set());
    }
    setExpandedProjects(new Set());
  }, [detectedProjects]);

  const toggleProject = (folderName: string) => {
    setSelectedProjects((prev) => {
      const next = new Set(prev);
      if (next.has(folderName)) {
        next.delete(folderName);
      } else {
        next.add(folderName);
      }
      return next;
    });
  };

  const toggleAll = () => {
    setSelectedProjects((prev) => {
      if (prev.size === detectedProjects.length) {
        return new Set();
      }
      return new Set(detectedProjects.map((project) => project.folderPath));
    });
  };

  const toggleExpand = (folderName: string) => {
    setExpandedProjects((prev) => {
      const next = new Set(prev);
      if (next.has(folderName)) {
        next.delete(folderName);
      } else {
        next.add(folderName);
      }
      return next;
    });
  };

  const selectProjects = (folderPaths: string[]) => {
    setSelectedProjects((prev) => {
      const next = new Set(prev);
      folderPaths.forEach((path) => next.add(path));
      return next;
    });
  };

  const deselectProjects = (folderPaths: string[]) => {
    setSelectedProjects((prev) => {
      const next = new Set(prev);
      folderPaths.forEach((path) => next.delete(path));
      return next;
    });
  };

  return {
    selectedProjects,
    expandedProjects,
    toggleProject,
    toggleAll,
    toggleExpand,
    setExpandedProjects,
    setSelectedProjects,
    selectProjects,
    deselectProjects,
  };
};
